import { action } from 'satcheljs';

/**
 * Remove conversations from tombstone
 * @param instanceKeys instanceKeys for the conversations to be removed from tombstone
 * @param folderId folder to which the conversation belong
 */
const removeFromTombstone = action(
    'removeFromTombstone',
    (instanceKeys: string[], folderId: string) => ({
        instanceKeys,
        folderId,
    })
);

export default removeFromTombstone;
